<div class="row g-6 mb-6">
    <div class="col-xl-12">
        <div class="mainContainer card overflow-auto margin mt-4">
            <div class="loader" *ngIf="loading">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
            <div class="reminder mb-0 d-flex bg-light justify-content-between flex-column flex-sm-row">
                <h5 class="card-title ps-4 mb-0 tableTitle">Active Contractors</h5>

                <div class="d-flex align-items-center ms-auto me-4 gap-2">

                    <!-- Month dropdown -->
                    <select class="form-select form-select-sm" style="width: 180px; height: 35px;"
                        [(ngModel)]="selectedMonth" (change)="searchActiveContractors()">
                        <option [ngValue]="null">Month</option>
                        <option *ngFor="let month of months" [value]="month.value">{{ month.name }}</option>
                    </select>

                    <!-- Year dropdown -->
                    <select class="form-select form-select-sm" style="width: 180px; height: 32px;"
                        [(ngModel)]="selectedYear" (change)="searchActiveContractors()">
                        <option [ngValue]="null">Year</option>
                        <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                    </select>

                </div>
            </div>
            <table matSort class="table table-hover table-nowrap">
                <thead class="table-light">
                    <tr>
                        <th mat-sort-header="to" scope="col">Agency</th>
                        <th mat-sort-header="subject" scope="col">Contractors</th>
                        <th mat-sort-header="sent_at" scope="col"># of Contractors</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="activeContractors.length > 0">
                        <tr class="dataColumn" *ngFor="let activeContractor of activeContractors">
                            <td>{{activeContractor.agency_name}}</td>
                            <td>
                                <div *ngFor="let contractor of activeContractor.candidates">
                                    <p>{{ contractor }}</p>
                                </div>
                            </td>
                            <td>{{activeContractor.count}}</td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="activeContractors.length == 0">
                        <tr>
                            <td class="text-heading font-bold text-center">No records found</td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
            <app-api-paginator *ngIf="totalCount" [totalCount]="totalCount" (onStepChange)="onStepChange($event)">
            </app-api-paginator>
        </div>
    </div>
</div>